import { ANALYTICS_EVENT_CLICK } from '../utils/constants'
import { setAnalyticsEvent } from './Analytics'

export const setShowMoreAnalyticsEvent = (selectedCategory: string, clicks: number) => {
  const event = {
    name: 'show more button',
    action: ANALYTICS_EVENT_CLICK,
    details: `${selectedCategory} clicks - ${clicks}`,
  }

  setAnalyticsEvent(event)
}
